module.exports = __webpack_public_path__ + "static/media/3VMR-1920-1934.e392148f.png";